import { Close } from '@mui/icons-material';
import Help from '@mui/icons-material/Help';
import {
    Alert,
    Box,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    FormControlLabel,
    FormLabel,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    Snackbar,
    Stack,
    Tab,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';
import { useNavigate, useParams } from 'react-router-dom';
import { useHelper } from '../../../../context/HelpSidebarContext';
import useDialog from '../../../../hooks/useDialog';
import useErrors from '../../../../hooks/useErrors';
import { useFetch } from '../../../../hooks/useFecth';
import server from '../../../../services/server';
import { stripBase64DataUrlPrefix, urlToBase64 } from '../../../../services/imageBase64';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ListInstructions from './ListInstructions';
import { DateTimePicker } from '@mui/x-date-pickers';
import SelectAdvertiser from '../../../../components/SelectAdvertiser';
import AddImage from '../../../../components/AddImage';

const CommissionField = React.forwardRef(function CommissionField(props, ref) {
    const { onChange, value, ...other } = props;
    return <IMaskInput {...other} value={String(value)} inputRef={ref} onAccept={value => onChange(props.name, value)} />;
});

const isPercentual = is => {
    if (is) {
        return {
            mask: 'num%',
            unmask: true,
            blocks: {
                num: {
                    mask: Number,
                    scale: 2, // Pode ajustar para mais precisão, se necessário
                    radix: ',',
                    min: 0,
                    max: 100,
                },
            },
        };
    } else {
        return {
            mask: 'R$ num',
            unmask: true,
            blocks: {
                num: {
                    mask: Number,
                    scale: 2,
                    thousandsSeparator: '.',
                    radix: ',',
                },
            },
        };
    }
};

function AdvertiserBrandModal({
    productData,
    advertiserBrandModal,
    handleCloseAdvertiserBrandModal,
    handleSubmitAdvertiserBrand,
    handleCloseAdvertiserBrand,
    handleChangeAdvertiserBrand,
    advertiserId,
    advertiserBrand,
}) {
    const { setErrors, enqueueSnackbar } = useErrors();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fieldNewAdvertiser, setFieldNewAdvertiser] = useState('');

    const handleSave = async () => {
        if (!advertiserId || !productData?.product?.organizationId) {
            enqueueSnackbar('Selecione um anunciante', { variant: 'warning' });
            return;
        }

        try {
            setIsSubmitting(true);

            const body = {};

            if (advertiserId === '__add') {
                body.advertiserName = productData.brand?.name;
            }

            if (advertiserId !== '__add') {
                body.advertiserId = advertiserId;
            }

            // Vincular anunciante à marca (brand) da Lomadee
            const response = await server.post(`brokers/lomadee/brands/${productData.product.organizationId}/link`, body);
    

            enqueueSnackbar('Anunciante vinculado à marca com sucesso!', { variant: 'success' });

            // Chamar callback original se existir
            if (handleSubmitAdvertiserBrand) {
                handleSubmitAdvertiserBrand();
            }
        } catch (error) {
            setErrors(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (productData?.brand?.name) {
            setFieldNewAdvertiser(productData.brand?.name);
        }
    }, [productData?.brand?.name]);

    return (
        <Dialog open={advertiserBrandModal} onClose={handleCloseAdvertiserBrandModal} maxWidth="sm" fullWidth>
            <DialogTitle>Vincular Anunciante &lt;-&gt; Loja</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ pt: 2 }}>
                    {productData?.product && (
                        <Alert severity="info">
                            <Typography variant="caption" display="block">
                                Loja: <strong>{productData.brand?.name}</strong>
                            </Typography>
                            <Typography variant="caption" display="block">
                                ID da Loja: {productData.product.organizationId}
                            </Typography>
                        </Alert>
                    )}

                    <SelectAdvertiser
                        value={advertiserId}
                        name="advertiserId"
                        onChange={handleChangeAdvertiserBrand}
                        label="Selecione o anunciante local"
                    />

                    {advertiserId === '__add' && (
                        <TextField
                            value={fieldNewAdvertiser}
                            onChange={e => setFieldNewAdvertiser(e.target.value)}
                            label="Nome da loja selecionada"
                            fullWidth
                        />
                    )}

                    {advertiserBrand && <TextField value={advertiserBrand.name} label="Nome do anunciante selecionado" disabled fullWidth />}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleCloseAdvertiserBrand} disabled={isSubmitting}>
                    Cancelar
                </Button>
                <Button variant="contained" onClick={handleSave} disabled={!advertiserId || isSubmitting}>
                    {isSubmitting ? 'Salvando...' : 'Vincular'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function Form({ data, mutate, productData }) {

    const { id } = useParams();
    const [tab, setTag] = useState('dados');
    const { open, handleClose } = useDialog('#offer');
    const { setErrors, enqueueSnackbar } = useErrors();
    const { openHelp } = useHelper();
    const navigation = useNavigate();
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    const advertiserIdTemp = sessionStorage.getItem('advertiserId');
    const [advertiserBrandModal, setAdvertiserBrandModal] = useState(false);
    const [advertiserId, setAdvertiserId] = useState('');
    const [advertiserBrand, setAdvertiserBrand] = useState(null);



    //quando abrir o modal vamos consultar o brandId no /brokers/lomadee/advertiser/:brandId e se success for false abre o modal para selecionar e salvar o anunciante com o brandId
    const { data: advertiserBrandData, mutate: mutateAdvertiserBrand } = useFetch(
        productData?.product?.organizationId ? `brokers/lomadee/brands/${productData.product.organizationId}/advertisers` : null,
    );

    console.log('DATA OFERTA : ', productData)


    //advertiserBrandData.data nao entrega array de anunciantes, entrega objeto com anunciante e brandId

    // useEffect(() => {
    //     console.log('advertiserBrandData teste  : ', advertiserBrandData);
    //     if (!Boolean(advertiserBrandData)) {
    //         // Sem vínculos - abrir modal para criar
    //         setAdvertiserBrandModal(true);
    //         setAdvertiserBrand(null);
    //     }

    //     if (Boolean(advertiserBrandData)) {
    //         console.log('advertiserBrandData', advertiserBrandData.advertiserId,  advertiserBrandData);
    //         // 1 vínculo - pré-selecionar automaticamente
    //         setFieldValue('advertiserId', advertiserBrandData.advertiserId);
    //         setAdvertiserBrand(productData.brand);
    //     }
    // }, [advertiserBrandData]);

    const handleSubmitAdvertiserBrand = () => {
        mutateAdvertiserBrand({ advertiserId, brandId: productData?.brand?.id });
    };

    const handleCloseAdvertiserBrandModal = () => {
        setAdvertiserBrandModal(false);
    };

    const handleCloseAdvertiserBrand = () => {
        setAdvertiserBrandModal(false);
    };

    const { values, handleSubmit, handleChange, setFieldValue, setValues, errors, isSubmitting } = useFormik({
        initialValues: {
            name: '',
            label: '',

            description: '',
            privateDescription: '',
            isCoupon: false,
            isCashback: false,
            isVoucher: false,
            code: '',
            url: '',
            externalUrl: false,

            isTracked: false,
            avaliableQty: '',
            offerChannel: 'virtual',

            isPercentual: false,
            value: '',

            isCashbackPercentual: false,
            valueCashback: '',

            rules: '',
            image: '',
            previewImage: '',
            megaBanner: '',

            file: '',
            productId: '',
            campaignId: '',
            expirationAt: '',
            status: true,
            advertiserId: '',

            offerValue: '',
            offerValueFrom: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);

                const advId = Number(values.advertiserId) || Number(advertiserBrandData?.advertiserId);
                if (!advId) {
                    enqueueSnackbar('Selecione ou vincule um anunciante antes de salvar.', { variant: 'warning' });
                    setSubmitting(false);
                    return;
                }

                const useLomadeeEnqueue =
                    values.offerChannel === 'lomadee' && values.socialSoulId && !productData;

                if (useLomadeeEnqueue) {
                    await server.post(`brokers/lomadee/enqueue/campaigns/${values.socialSoulId}/sync`, {
                        advertiserId: advId,
                        name: values.name,
                        label: values.label,
                        description: values.description,
                        rules: values.rules,
                        isPercentual: values.isPercentual,
                        value:
                            values.value !== '' && values.value !== undefined && values.value !== null
                                ? Number(values.value)
                                : undefined,
                        valueCashback:
                            values.valueCashback !== '' &&
                            values.valueCashback !== undefined &&
                            values.valueCashback !== null
                                ? Number(values.valueCashback)
                                : undefined,
                        isCashbackPercentual: values.isCashbackPercentual,
                    });
                    sessionStorage.removeItem('advertiserId');
                    enqueueSnackbar(
                        'Importação enfileirada. A oferta será criada em instantes; acompanhe em Brokers → Lomadee — fila.',
                        { variant: 'success' },
                    );
                    await mutate();
                    handleClose();
                    setSubmitting(false);
                    return;
                }

                const { data } = await server.post(`offer`, {
                    ...values,
                    advertiserId: advId,
                    value: Number(values.value),
                });
                sessionStorage.removeItem('advertiserId');
                enqueueSnackbar(`Oferta ${values.name} adicionada.`);

                await mutate();
                handleClose();
                setSubmitting(false);
            } catch (error) {
                console.log('Erro durante o envio:', error);
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    const normalizeOfferImageFields = async (imageValue) => {
        if (!imageValue) return { image: '', previewImage: '' };

        const str = String(imageValue);

        // Se for URL Amazon (já está no S3), mantemos como URL para evitar nova conversão
        // e também evitar que o backend tente re-upload (ele checa `!image.includes('amazon')`).
        if (/^https?:\/\//i.test(str) && str.includes('amazon')) {
            return { image: str, previewImage: str };
        }

        // Se já vier em dataURL, extrai o base64 puro para o backend.
        if (str.startsWith('data:image/')) {
            return { image: stripBase64DataUrlPrefix(str), previewImage: str };
        }

        // Se for URL comum, converte para base64 puro (UploadToS3 precisa disso).
        if (/^https?:\/\//i.test(str)) {
            const base64 = await urlToBase64(str);
            return { image: base64, previewImage: str };
        }

        // Caso seja base64 puro (sem prefixo), cria um dataURL só para prévia.
        return { image: str, previewImage: `data:image/png;base64,${str}` };
    };

    const handleDelete = () => {
        setConfirmAction(() => async () => {
            try {
                await server.delete(`offer/${values.id}`);
                enqueueSnackbar('Oferta excluida com sucesso!');
                await mutate();
                handleClose();
            } catch (error) {
                setErrors('Erro ao deletar anunciante.', error);
            }
            setConfirmOpen(false);
        });
        setConfirmOpen(true);
    };

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (productData) {
                // Dados de produto da Lomadee
                const { product, option, pricing, commission } = productData;
                const avaliableQty = productData?.option?.stocks?.find(stock => stock.value > 0)?.value || 0;

                const imageFields = await normalizeOfferImageFields(product.images?.[0]?.url || '');
                if (cancelled) return;

                const bodyOffer = {
                    name: product.name || '',
                    description: product.description || '',
                    url: product.url || '',
                    externalUrl: true,
                    isTracked: true,
                    socialSoulId: product.id,
                    offerChannel: 'lomadee',
                    advertiserId: advertiserIdTemp ? Number(advertiserIdTemp) : '',
                    image: imageFields.image,
                    previewImage: imageFields.previewImage,
                    offerValue: pricing.price || '',
                    offerValueFrom: pricing.listPrice || '',
                    avaliableQty: avaliableQty,

                    // Pré-preencher com cashback = 0 para o gestor definir
                    isCashback: true,
                    isCashbackPercentual: false,
                    valueCashback: 0,
                    // Guardar informações extras
                    privateDescription: `EAN: ${option.ean || 'N/A'} | Seller: ${option.seller || 'N/A'} | Comissão disponível: R$ ${commission.toFixed(2)}`,
                };

                setValues(bodyOffer, true);
                return;
            }

            if (data) {
                // Nova estrutura de campanhas da Lomadee
                const imageFields = await normalizeOfferImageFields(data.image || '');
                if (cancelled) return;

                const bodyOffer = {
                    name: data.name || data.description || '',
                    label: data.description || '',
                    rules: data.rules || '',
                    code: data.code || '',
                    value: data.discountValue || 0,
                    valueCashback: data.cashbackValue || 0,
                    status: data.status === 'active',
                    url: data.url || '',
                    externalUrl: true,
                    isTracked: true,
                    socialSoulId: data.id,
                    offerChannel: 'lomadee',
                    advertiserId: advertiserIdTemp ? Number(advertiserIdTemp) : '',
                    image: imageFields.image,
                    previewImage: imageFields.previewImage,
                    offerValue: data.price || '',
                    offerValueFrom: data.priceFrom || '',
                    expirationAt: data.validUntil ? new Date(data.validUntil) : '',
                };

                // Determinar tipo de campanha
                switch (data.type) {
                    case 'PersonalCoupon':
                    case 'GenericCoupon':
                        bodyOffer.isCoupon = true;
                        bodyOffer.isPercentual = data.discountType === 'percentage';
                        break;

                    case 'Offer':
                        if (data.hasVoucher) {
                            bodyOffer.isVoucher = true;
                            bodyOffer.isPercentual = data.discountType === 'percentage';
                        }
                        if (data.hasCashback) {
                            bodyOffer.isCashback = true;
                            bodyOffer.isCashbackPercentual = data.cashbackType === 'percentage';
                        }
                        break;
                    default:
                        break;
                }

                setValues(bodyOffer, true);
            }
        };

        run();

        return () => {
            cancelled = true;
        };
    }, [data, productData, advertiserIdTemp, setValues]);

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('warning');

    const handleTypeOffer = (field, value) => {
        // setFieldValue(field, value);

        if (field === 'isVoucher' && (values.isCoupon || values.isCashback)) {
            setAlertMessage('Somente Cupom e Cashback podem ser selecionados juntos.');
            setAlertSeverity('warning');
            setAlertOpen(true);
            return; // Não permite a seleção do voucher
        }

        // Se o voucher não estiver sendo selecionado, permite a seleção do cupom ou cashback
        if (field === 'isCoupon') {
            setFieldValue('isCoupon', value);
            if (value) {
                setFieldValue('isVoucher', false); // Desmarcar voucher se cupom for selecionado
            }
        } else if (field === 'isCashback') {
            setFieldValue('isCashback', value);
            if (value) {
                setFieldValue('isVoucher', false); // Desmarcar voucher se cashback for selecionado
            }
        } else {
            setFieldValue(field, value); // Para o caso do voucher
        }
    };

    return (
        <TabContext value={tab}>
            {/* Alerta de sucesso ou erro */}
            <Snackbar
                open={alertOpen}
                autoHideDuration={6000}
                onClose={() => setAlertOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity} variant="filled">
                    {alertMessage}
                </Alert>
            </Snackbar>

            <Dialog open={open} fullWidth maxWidth="sm" onClose={handleClose}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <DialogTitle>{values.id ? 'Editando oferta' : 'Adicionando'} oferta</DialogTitle>
                    <Stack direction="row" columnGap={1} alignItems="center" px={2}>
                        <IconButton size="small" onClick={e => openHelp('offer_avaliableQty')}>
                            <Help />
                        </IconButton>
                        <IconButton size="small" onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </Stack>
                </Stack>

                <Divider />
                <TabList onChange={(_, value) => setTag(value)}>
                    <Tab label="Dados da oferta" value="dados" />
                    {/* {Boolean(values.id) && <Tab label="Instruções e regras" value="instructions" />} */}
                </TabList>
                <DialogContent dividers sx={{ p: 0 }} component="form" onSubmit={handleSubmit}>
                    <TabPanel value="dados">
                        <Stack rowGap={2}>
                            <AddImage
                                onChange={setFieldValue}
                                name="image"
                                value={values.previewImage || values.image}
                                canvaWidth={300}
                                canvaHeight={300}
                                label="Dimensões recomendadas: 300x300px"
                            />
                            {Boolean(values.id) && (
                                <>
                                    {/*  */}
                                    {/* <AddImage
                                    onChange={setFieldValue}
                                    name="megaBanner"
                                    value={values.previewMegaBanner || values.megaBanner}
                                    label="Dimensões recomendadas 500x200px"
                                /> */}
                                </>
                            )}

                            <FormControl>
                                <FormLabel>Tipo de oferta</FormLabel>
                                <ToggleButtonGroup fullWidth>
                                    <ToggleButton
                                        value="isCoupon"
                                        selected={values.isCoupon}
                                        onChange={(e, value) => handleTypeOffer(value, !values.isCoupon)}
                                    >
                                        Cupom
                                    </ToggleButton>
                                    <ToggleButton
                                        value="isCashback"
                                        selected={values.isCashback}
                                        onChange={(e, value) => handleTypeOffer(value, !values.isCashback)}
                                    >
                                        Cashback
                                    </ToggleButton>
                                    {/* <ToggleButton
                                        value="isVoucher"
                                        selected={values.isVoucher}
                                        onChange={(e, value) => handleTypeOffer(value, !values.isVoucher)}
                                    >
                                        Voucher
                                    </ToggleButton> */}
                                    {/* <ToggleButton value="isProduct" selected={values.isProduct} onChange={(e,value)=>handleTypeOffer(value, !values.isProduct)} disabled>
                                    Produto
                                </ToggleButton> */}
                                </ToggleButtonGroup>
                            </FormControl>

                            {/* <SelectAdvertiser
                                value={values.advertiserId}
                                name="advertiserId"
                                onChange={setFieldValue}
                                label="Selecione o anunciante"
                            /> */}
                            <Typography>{values.advertiserId}</Typography>
                            <TextField onChange={handleChange} label="Titulo da oferta" name="name" value={values.name} />
                            <TextField onChange={handleChange} label="Label" name="label" value={values.label} />

                            {/* <FormControl>
                            <InputLabel size="small">Tipo de oferta</InputLabel>
                            <Select label="Tipo de oferta" name="offerChannel" defaultValue="virtual" value={values.offerChannel} onChange={handleChange}>
                                <MenuItem value="physical">Físico</MenuItem>
                                <MenuItem value="virtual">Virtual</MenuItem>
                            </Select>
                        </FormControl> */}
                            {(values.isCashback || values.isCoupon) && (
                                <>
                                    <TextField required onChange={handleChange} label="Site da oferta" name="url" value={values.url} />
                                    {values.isCoupon && (
                                        <TextField
                                            fullWidth
                                            onChange={handleChange}
                                            label="Código do Cupom"
                                            name="code"
                                            value={values.code}
                                            error={!!errors.code}
                                            helperText={errors.code}
                                        />
                                    )}
                                    <FormControlLabel
                                        label="O site abre fora do app?"
                                        control={
                                            <Switch checked={values.externalUrl} onChange={e => setFieldValue('externalUrl', e.target.checked)} />
                                        }
                                    />
                                    {/* <FormControl orientation="horizontal">
                                            <InputLabel size="small">
                                                O site abre fora do app
                                                <IconButton size="small" onClick={e => openHelp('offer_externalUrl')}>
                                                    <Help />
                                                </IconButton>
                                            </InputLabel>
                                            
                                        </FormControl> */}
                                </>
                            )}
                            <TextField
                                rows={3}
                                multiline
                                onChange={handleChange}
                                label="Descrição da oferta"
                                name="description"
                                value={values.description}
                            />

                            {/* <InputLabel size="small">
                                    Regras
                                    <IconButton size="small" onClick={e => openHelp('offer_rules')}>
                                        <Help />
                                    </IconButton>
                                </InputLabel> */}
                            <TextField rows={2} multiline onChange={handleChange} label="Regras gerais" name="rules" value={values.rules} />

                            {/* <InputLabel size="small">
                                    Quantidade disponível
                                    <IconButton size="small" onClick={e => openHelp('offer_avaliableQty')}>
                                        <Help />
                                    </IconButton>
                                </InputLabel> */}
                            <TextField
                                type="number"
                                onChange={handleChange}
                                label="Quantidade disponível"
                                name="avaliableQty"
                                value={values.avaliableQty}
                            />

                            <TextField
                                onChange={handleChange}
                                label="Preço do produto"
                                name="offerValue"
                                value={values.offerValue}
                                error={!!errors.offerValue}
                                helperText={errors.offerValue}
                                InputProps={{
                                    inputProps: { ...isPercentual(false) },
                                    inputComponent: CommissionField,
                                }}
                            />

                            <TextField
                                onChange={handleChange}
                                label="Preço do produto de origem"
                                name="offerValueFrom"
                                value={values.offerValueFrom}
                                error={!!errors.offerValueFrom}
                                helperText={errors.offerValueFrom}
                                InputProps={{
                                    inputProps: { ...isPercentual(false) },
                                    inputComponent: CommissionField,
                                }}
                            />

                            {/* <TextField onChange={handleChange} label="Valor do desconto" name="value" value={values.value} /> */}

                            {(values.isCoupon || values.isVoucher) && (
                                <TextField
                                    fullWidth
                                    label="Valor Desconto Cupom"
                                    name="value"
                                    value={String(values.value)}
                                    onChange={setFieldValue}
                                    error={!!errors.value}
                                    helperText={errors.value}
                                    InputProps={{
                                        inputProps: { ...isPercentual(values.isPercentual) },
                                        inputComponent: CommissionField,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <FormControlLabel
                                                    sx={{ m: 0, p: 0 }}
                                                    control={
                                                        <Checkbox
                                                            checked={values.isPercentual}
                                                            onChange={e => setFieldValue('isPercentual', e.target.checked)}
                                                        />
                                                    }
                                                    label="%"
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}

                            {values.isCashback && (
                                <TextField
                                    fullWidth
                                    label="Valor Desconto Cashback"
                                    name="valueCashback"
                                    value={String(values.valueCashback)}
                                    onChange={setFieldValue}
                                    error={!!errors.valueCashback}
                                    helperText={errors.valueCashback}
                                    InputProps={{
                                        inputProps: { ...isPercentual(values.isCashbackPercentual) },
                                        inputComponent: CommissionField,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <FormControlLabel
                                                    sx={{ m: 0, p: 0 }}
                                                    control={
                                                        <Checkbox
                                                            checked={values.isCashbackPercentual}
                                                            onChange={e => setFieldValue('isCashbackPercentual', e.target.checked)}
                                                        />
                                                    }
                                                    label="%"
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}

                            {/* <FormControlLabel
                            control={<Switch checked={values.isTracked} onChange={e => setFieldValue('isTracked', e.target.checked)} />}
                            label="Oferta trackeada"
                        />

                        */}

                            {Boolean(values.id) && (
                                <>
                                    <DateTimePicker
                                        value={values.expirationAt ? new Date(values.expirationAt) : null}
                                        format="dd/MM/yyyy HH:mm"
                                        onChange={e => setFieldValue('expirationAt', e)}
                                        name="expirationAt"
                                        label="Expira em"
                                        slotProps={{
                                            textField: {
                                                error: !!errors.expirationAt,
                                                helperText: errors.expirationAt,
                                                fullWidth: true,
                                            },
                                            field: { clearable: true, onClear: () => setFieldValue('expirationAt', '') },
                                        }}
                                    />
                                    <FormControlLabel
                                        control={<Switch checked={values.status} onChange={e => setFieldValue('status', e.target.checked)} />}
                                        label="Status da oferta"
                                    />
                                </>
                            )}
                            <Divider> Dados internos </Divider>
                            <TextField
                                rows={3}
                                multiline
                                onChange={handleChange}
                                label="Observações (Privado)"
                                name="privateDescription"
                                value={values.privateDescription}
                            />
                        </Stack>
                    </TabPanel>

                    <TabPanel value="instructions">
                        {/* <Stack rowGap={2}>
                                <Button sx={{alignSelf: 'flex-end'}} variant='outlined'>Adicionar item</Button>
                                 
                                <List >
                                    <ListItem variant="outlined">
                                        <ListItemText primary="Instrução 1" primaryTypographyProps={{ variant: 'h4' }} secondary="Instrução 2" />
                                    </ListItem>
                                    
                                </List>
                            </Stack> */}

                        <ListInstructions offerId={values.id} mutate={mutate} />
                    </TabPanel>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        {Boolean(values.id) && (
                            <Box>
                                <Button variant="outlined" color="error" onClick={handleDelete}>
                                    Excluir
                                </Button>
                            </Box>
                        )}
                        <Box>
                            <Button disabled={isSubmitting} variant="contained" onClick={handleSubmit}>
                                {isSubmitting ? (
                                    <>
                                        <CircularProgress size={18} color="inherit" sx={{ mr: 1, verticalAlign: 'middle' }} /> Salvando...
                                    </>
                                ) : 'Salvar e continuar'}
                            </Button>
                        </Box>
                    </Stack>
                </DialogActions>
            </Dialog>
            <ConfirmationModal
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onConfirm={confirmAction}
                title="Confirmação de Exclusão"
                message="Tem certeza de que deseja excluir esta oferta?"
            />
            <AdvertiserBrandModal
                productData={productData}
                advertiserBrandModal={advertiserBrandModal}
                handleCloseAdvertiserBrandModal={handleCloseAdvertiserBrandModal}
                handleSubmitAdvertiserBrand={handleSubmitAdvertiserBrand}
                handleCloseAdvertiserBrand={handleCloseAdvertiserBrand}
                handleChangeAdvertiserBrand={setFieldValue}
                advertiserId={values.advertiserId}
                advertiserBrand={advertiserBrand}
            />
        </TabContext>
    );
}

export default function DialogOffer({ mutate, coupon, campaign, productData, isSynced }) {
    
    const { open } = useDialog('#offer');
    if (open) return <Form mutate={mutate} data={campaign || coupon} productData={productData} isSynced={isSynced}  />;
}
